export default "__VITE_ASSET__994191f4__"